import { RouteComponentProps } from "@reach/router"
// Components
import BIDataExportWidget from 'components/dashboard/bi-data-export-widget'
import { DashboardWidgetsContainer_s, DashboardWidget_s, Dashboard_s, LearningCenter_s, WidgetBody_s, WidgetHeader_s } from 'components/dashboard/dashboard-styles'
import RecentPropertiesWidget from "components/dashboard/recent-properties-widget"
import UWWidget from "components/dashboard/uw-widget"
import Subnav from "components/subnav"
import { PDFIcon } from "images/icons/general/"
// Icons
import { CompressIcon, ExpandIcon } from "images/icons/tools/"
import React, { FC, useState } from "react"
import Isvg from "react-inlinesvg"
// Help files
//import { GettingStarted, Hotkeys } from "static"
// Styles
import { H4 } from "styles/app-styles"

const Dashboard: FC<RouteComponentProps> = (props) => {
  const [RPExpanded, setRPExpanded] = useState<boolean>(false)
  const [UWExpanded, setUWExpanded] = useState<boolean>(false)
  const [BIExpanded, setBIExpanded] = useState<boolean>(false)

  return (
    <div>
      <Subnav section="DASHBOARD" tabs={[]} />
      <Dashboard_s>
        <LearningCenter_s>
          <details>
            <summary>Learning Center</summary>
            <div>
              <div>
                <span>For more information</span>
                <span>Check out our <a href="https://rsquaredcre.zendesk.com/hc/en-us/categories/115000446654-rDCF" target="_blank">Knowledge Base</a></span>
              </div>
              <div>
                <a href="https://rdcf-static.s3.us-west-2.amazonaws.com/pdf/rDCFGettingStarted.pdf" target="_blank">
                  <Isvg src={PDFIcon} width={28} />
                  <span>View & Download our Getting Started Guide</span>
                </a>
              </div>
              <div>
                <a href="https://rdcf-static.s3.us-west-2.amazonaws.com/pdf/rDCFHotkeys.pdf" target="_blank">
                  <Isvg src={PDFIcon} width={28} />
                  <span>View & Download our Hotkey/Navigation Guide</span>
                </a>
              </div>
            </div>
          </details>
        </LearningCenter_s>
        <DashboardWidgetsContainer_s>
          <DashboardWidget_s expanded={RPExpanded}>
            <WidgetHeader_s>
              <div><H4>Recent Properties</H4></div>
              <div>
                <a onClick={()=>setRPExpanded(!RPExpanded)}>
                  { RPExpanded ? <Isvg src={CompressIcon} width={16} /> : <Isvg src={ExpandIcon} width={16} /> }
                </a>
              </div>
            </WidgetHeader_s>
            <WidgetBody_s>
              <RecentPropertiesWidget />
            </WidgetBody_s>
          </DashboardWidget_s>
          <DashboardWidget_s expanded={UWExpanded}>
            <WidgetHeader_s>
              <div><H4>Underwriting Workbooks</H4></div>
              <div>
                <a onClick={()=>setUWExpanded(!UWExpanded)}>
                  { UWExpanded ? <Isvg src={CompressIcon} width={16} /> : <Isvg src={ExpandIcon} width={16} /> }
                </a>
              </div>
            </WidgetHeader_s>
            <WidgetBody_s>
              <UWWidget />
            </WidgetBody_s>
          </DashboardWidget_s>
          <DashboardWidget_s expanded={BIExpanded}>
            <WidgetHeader_s>
              <div><H4>BI Data Exports</H4></div>
              <div>
                <a onClick={()=>setBIExpanded(!BIExpanded)}>
                  { BIExpanded ? <Isvg src={CompressIcon} width={16} /> : <Isvg src={ExpandIcon} width={16} /> }
                </a>
              </div>
            </WidgetHeader_s>
            <WidgetBody_s>
              <BIDataExportWidget />
            </WidgetBody_s>
          </DashboardWidget_s>
        </DashboardWidgetsContainer_s>
      </Dashboard_s>
    </div>
  )
}

export default Dashboard
